import { css } from '@emotion/react'
import { Tabs } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { TabLink } from 'components/route'
import { useAnalytics } from 'hooks/analytics/useAnalytics'
import { useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions.generated'
import { grupoCboVisualizarProntuario } from 'view/cidadao/authorization/acessos'

import { grupoCboHistorico } from '../acessos'
import { ACOMPANHAMENTOS_URL } from '../acompanhamentos/AcompanhamentosView'

export interface AtendimentoHeaderTabsProps {
  cidadaoId: ID
  labelEscutaPreAtendimento?: string
  renderFolhaRosto?: boolean
  renderSoap?: boolean
  renderVacinacao?: boolean
  renderHistorico?: boolean
  renderCadastroCidadao?: boolean
  renderEscutaInicial?: boolean
  renderAgendamentos?: boolean
  renderDiscussaoCaso?: boolean
  renderAcompanhamentos?: boolean
  renderSistemasExternos?: boolean
  renderProntuarioFamiliar?: boolean
}

export function AtendimentoHeaderTabs(props: AtendimentoHeaderTabsProps) {
  const {
    cidadaoId,
    labelEscutaPreAtendimento,
    renderFolhaRosto = true,
    renderSoap = true,
    renderVacinacao = true,
    renderHistorico = true,
    renderCadastroCidadao = true,
    renderAgendamentos = true,
    renderEscutaInicial = false,
    renderDiscussaoCaso,
    renderAcompanhamentos,
    renderSistemasExternos = false,
    renderProntuarioFamiliar = true,
  } = props

  const { analytics } = useAnalytics()
  const match = useRouteMatch()

  return (
    <Tabs
      style={css`
        border-bottom-width: 0;
      `}
      data-testid='AtendimentoHeaderTab'
    >
      {renderFolhaRosto && (
        <CheckPermission
          hasAnyCbo={[grupoCboVisualizarProntuario]}
          hasAnyPermission={[Permissions.visualizarProntuario]}
        >
          <TabLink to={`${match.url}/folha-rosto`}>Folha de rosto</TabLink>
        </CheckPermission>
      )}
      {renderSoap && <TabLink to={`${match.url}/soap`}>SOAP</TabLink>}
      {renderEscutaInicial && <TabLink to={`${match.url}/escuta-inicial`}> {labelEscutaPreAtendimento}</TabLink>}
      {renderHistorico && (
        <CheckPermission permission={grupoCboHistorico.visualizar}>
          <TabLink to={`${match.url}/historico`} onClick={() => analytics.logEvent('click_tab_atendimento_historico')}>
            Histórico
          </TabLink>
        </CheckPermission>
      )}
      {renderVacinacao && <TabLink to={`${match.url}/vacinacao`}>Vacinação</TabLink>}

      {renderAcompanhamentos && <TabLink to={`${match.url}/${ACOMPANHAMENTOS_URL}`}>Acompanhamentos</TabLink>}

      {renderCadastroCidadao && (
        <CheckPermission permission={Permissions.gestaoDeCadastros}>
          <TabLink to={`${match.url}/cadastro-cidadao`}>Cadastro individual</TabLink>
        </CheckPermission>
      )}
      {renderProntuarioFamiliar && (
        <CheckPermission permission={Permissions.gestaoDeCadastros.visualizarCadastroIndividual.cadastrarEEditar}>
          <TabLink to={`${match.url}/prontuario-familiar`}> Prontuário familiar</TabLink>
        </CheckPermission>
      )}

      {renderAgendamentos && (
        <CheckPermission permission={Permissions.visualizarAgenda}>
          <TabLink to={`${match.url}/agendamentos/${cidadaoId}`}>Agendamentos</TabLink>
        </CheckPermission>
      )}

      {renderDiscussaoCaso && <TabLink to={`${match.url}/discussao-caso`}>Discussão de caso</TabLink>}

      {renderSistemasExternos && <TabLink to={`${match.url}/sistemas-externos`}>Sistemas Externos</TabLink>}
    </Tabs>
  )
}
